import React, { useEffect } from 'react'

interface Props {
  onBlur: (event:FocusEvent)=>void
}

const BlurListener:ReactFC<Props> = ({ children, onBlur }) => {
  useEffect(() => {
    const handleBlur = (e:FocusEvent) => {
      onBlur(e)
    }
    window.addEventListener('blur', handleBlur)
    return () => {
      window.removeEventListener('blur', handleBlur)
    }
  }, [])

  return (
    <>
      {
        children
      }
    </>
  )
}
export default BlurListener
